import React from "react";
import { Box } from "@mui/material";
import PrivacyPolicies from "./PrivacyPolicies";

const container = {
    height: "100vh",
    bgcolor: "#f5f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};

const card = {
    width: "420px",
    maxWidth: "95%",
    height: "97vh",
    bgcolor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    overflowY: "auto",
    p: 2,
};

const contentStyles = {
    fontSize: "13px",
    lineHeight: 1.7,
    color: "#333",

    "& h2": {
        fontSize: "18px",
        fontWeight: "bold",
        margin: "16px 0 8px",
        lineHeight: 1.4,
        letterSpacing: "normal",
        wordBreak: "break-word",
        fontFamily: "inherit",
    },

    "& p": {
        fontSize: "13px",
        marginBottom: "8px",
        wordBreak: "break-word",
        lineHeight: 1.7,
    },

    "& a": {
        color: "#1976d2",
        textDecoration: "underline",
        wordBreak: "break-all",
        fontSize: "13px",
    },

    "& table": {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "8px",
        marginBottom: "12px",
    },

    "& td": {
        border: "1px solid #ddd",
        padding: "6px",
        fontSize: "12px",
        lineHeight: 1.6,
        verticalAlign: "top",
    },

    "& td:first-of-type": {
        backgroundColor: "#fff",
        fontWeight: "bold",
        width: "40%",
    },
};

const PrivacyPolicy = () => {
    return (
        <Box sx={container}>
            <Box sx={card}>
                <Box sx={contentStyles}>
                    <PrivacyPolicies />
                </Box >
            </Box>
        </Box>
    );
};

export default PrivacyPolicy;